/* ================================================================ */
// Index | index.jsx
/* ================================================================ */
/* ========================================== */
// IMPORTS
/* ========================================== */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// Store
import store from './store';
// Actions
import { windowResize } from './actions/Global';
import { fetchInit, fetchGlobe } from './actions/Data';
// Local Components
import Layout from './components/Layout';
// Log Rocket
import LogRocket from 'logrocket';
// Service Worker
import * as serviceWorker from './serviceWorker/sw.js';
// Auth0
import { Auth0Provider } from './auth0/auth0.jsx';
import config from './auth0/config.json';
/* ========================================== */
// FUNCTIONS
/* ========================================== */
/* ========================================== */
/**
 * onRedirectCallback
 * ------------------
 * Routes user to the right place after login
 * @param {*} appState
 */
const onRedirectCallback = appState => {
    window.history.replaceState(
        {},
        document.title,
        appState && appState.targetUrl ? appState.targetUrl : window.location.pathname
    );
};
/* ========================================== */
/**
 * Resize
 * ------
 * Triggers width and height state update with
 * current window inner width and inner height values
 */
function resize() {
    store.dispatch(windowResize(window.innerWidth, window.innerHeight));
}
/* ========================================== */
// WINDOW EVENTS
/* ========================================== */
var timeout = false;
var delay = 250;
/* ======================== */
// USER AGENT CHECK
/* ======================== */
if(window.navigator.userAgent.match('Android')) {
    /* ========================================== */
    /**
     * Window Orientation Change
     * -------------------------
     * Triggers resize on device orientation change
     */
    window.addEventListener('orientationchange', ()=>{
        store.dispatch(windowResize(window.innerWidth, window.innerHeight));
    });
} else {
    /* ========================================== */
    /**
     * Window Resize
     * -------------
     * Triggers resize function with a timeout delay
     * for debouncing
     */
    window.addEventListener('resize', () => {
        // clear the timeout
        clearTimeout(timeout);
        // start timing for event "completion"
        timeout = setTimeout(resize, delay);
    });
}
/* ========================================== */
/**
 * Window Load
 * -----------
 * Triggers window resize on initial load of the
 * window to update window width and height states
 */
window.addEventListener('load', () => {
    // LogRocket
    //if(process.env.NODE_ENV === 'production')
    //    LogRocket.init('nozm8c/myglobe');
    store.dispatch(windowResize(window.innerWidth, window.innerHeight));
    const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    console.log('subdomain', subdomain);
    console.log('subdomain', window.location.host);
    if(/*process.env.NODE_ENV === 'production' &&*/ subdomain && subdomain!="131")
        store.dispatch(fetchGlobe(subdomain));
    else
        store.dispatch(fetchGlobe('rous'));
});
/* ========================================== */
// RENDER
/* ========================================== */
const app = document.getElementById('app');
ReactDOM.render(
    //<React.StrictMode>
    <Auth0Provider
        domain={config.domain}
        client_id={config.client_id}
        redirect_uri={window.location.protocol+'//'+window.location.host||config.redirect_uri}
        audience={config.audience}
        onRedirectCallback={onRedirectCallback}
    >
        <Provider store={store} >
            <Layout />
        </Provider>
    </Auth0Provider>
    //</React.StrictMode>
    , app
);
serviceWorker.register();